import { useEffect } from "react";

/**
 * Set document.title to `Happy Lab · {title}` while the component is
 * mounted, restoring the previous title on unmount. Pass null/empty for the
 * bare base "Happy Lab".
 */
export const useDocumentTitle = (title) => {
    useEffect(() => {
        const prev = document.title;
        document.title = title ? `Happy Lab · ${title}` : "Happy Lab";
        return () => {
            document.title = prev;
        };
    }, [title]);
};
